import { queryOptions } from '@tanstack/react-query';
import { getCulpritVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleInformation/getCulpritVehicleInformation.type';
import { getCulpritVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleInformation/getCulpritVehicleInformationFunction';

export const getCulpritVehicleInformationOption = ({
  id,
}: getCulpritVehicleInformationType) =>
  queryOptions({
    queryKey: ['get-culprit-part_one-vehicle-information', id],
    queryFn: () => getCulpritVehicleInformationFunction({ id }),
  });
